import { z } from 'zod';

export const InputSchema = z.object({
    ringFencedFunds: z.boolean()
});

export type ChangeRingFencedFundsInput = z.infer<typeof InputSchema>;



